module.exports = "/images/Run better promotions-2 2.svg?c24f2ba59f4750a976bbe0f0f7ad834f";